import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import {
  BottomDocked,
  Button,
  Col,
  colors,
  Content,
  H3,
  H4,
  Message,
  Page,
  Row,
  Spacer,
} from '../components'
import { isIOS } from '../helper/userAgents'

const Image = styled.img`
  width: 100%;
  max-width: 450px;
`

const Images = {
  IOS: {
    Safari: {
      Step1: '/instructions/IOS-Safari-Menu.png',
      Step2: '/instructions/IOS-Safari-Add-to-Homescreen.png',
    },
    Chrome: {
      Step1: '/instructions/IOS-Chrome-Menu.png',
      Step2: '/instructions/IOS-Chrome-Add-to-Homescreen.png',
    },
    Firefox: {
      Step1: '/instructions/IOS-Firefox-Menu.png',
      Step2: '/instructions/IOS-Firefox-Add-to-Homescreen.png',
    },
  },
  ANDROID: {
    Chrome: {
      Step1: '/instructions/Android-Menu.png',
      Step2: '/instructions/Android-Add-to-Homescreen.png',
    },
  },
}

export const Instructions = () => {
  const navigate = useNavigate()

  const images = isIOS ? Images.IOS.Safari : Images.ANDROID.Chrome

  return (
    <Page>
      <Content color={colors.textAlt}>
        <Col gap={4} flexDirection="column">
          <H3>
            <Message id="INSTRUCTIONS_HEADLINE" />
          </H3>

          <H4>
            <Message id="INSTRUCTIONS_STEP_1" />
          </H4>

          <Col alignItems="center" flexDirection="column">
            <Image src={images.Step1} alt="Step 1" />
          </Col>

          <H4>
            <Message id="INSTRUCTIONS_STEP_2" />
          </H4>

          <Col alignItems="center" flexDirection="column">
            <Image src={images.Step2} alt="Step 2" />
          </Col>
        </Col>

        <BottomDocked>
          <Row>
            <Button
              onClick={() => {
                navigate(-1)
              }}
            >
              <Message id="BACK" />
            </Button>
            <Spacer size={2} />
          </Row>
        </BottomDocked>
      </Content>
    </Page>
  )
}
